import Head from 'next/head';
import { OpportunitiesBrowser } from '@/components/OpportunitiesBrowser';
import { ConsumerModeCallout } from '@/components/ConsumerModeCallout';
import { useSiteSettings } from '@/lib/hooks/useSiteSettings';

export default function OpportunitiesPage() {
  const { settings, isLoading: siteSettingsIsLoading } = useSiteSettings();
  if (siteSettingsIsLoading) return null;
  return (
    <>
      <Head>
        <title>Opportunities | Sizzlenz</title>
        <meta name="description" content="Opportinities for brands, businesses and places" />
      </Head>
      <OpportunitiesBrowser
        title="Opportunities"
        subtitle={<>Opportunities for brands, businesses and places</>}
        showOwner
        showStatus
        showInterestCount="non-zero"
        signInRedirectTo="/opportunities"
        hardCodedFilters={{ categories: ['trade', 'workplace'] }}
        mapConfig={{
          enabled: false,
          initialCenter: settings?.opportunities?.initialMapCenter,
          initialZoom: settings?.opportunities?.initialMapZoom,
        }}
      />
    </>
  );
}
